import React, { useEffect, useState, useRef } from "react";
import GridHeader from "./GridHeader";
import GridItem from "./GridItem";
import { Pagination } from "@material-ui/lab";
import { Grid, makeStyles } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import DMSelect from "../DMSelect";
import { orderBy } from "lodash";

const CustomerGrid = (props) => {
  const useStyles = makeStyles((theme) => ({
    noDataFound: {
      fontSize: "20px",
      display: "flex",
      justifyContent: "center",
      padding: "40px 0",
      cursor: "pointer",
      width: "100%",
    },
  }));

  const classes = useStyles();


  const [loading, setLoading] = useState(props.loading);


  useEffect(() => {
    setLoading(props.loading);
  }, [props.loading]);


  // const sortAcs = (arr, sortType, sortKey) => {
  //   if (sortType && sortKey && props.data?.length) {
  //     let temp = orderBy(
  //       arr,
  //       [(sortKeydata) => isNaN(sortKeydata[sortKey]) ? sortKeydata[sortKey]?.toString()?.toLowerCase() : sortKeydata[sortKey]],
  //       [sortType]
  //     );
  //     setData(temp);
  //   } else {
  //     setData([...props.data]);
  //   }
  // };

  const handleSorting = (col, key = null) => {
    let type = "";
    let tempCol = "";
    if (col === props.sortCol && key) {
      if (props.sortType === "" || props.sortType === "desc") {
        type = "asc";
      } else if (props.sortType === "asc") {
        type = "desc";
      }
      tempCol = col;
    } else {
      type = "asc";
      tempCol = col;
    }
    if(props.onSortChange){
      props.onSortChange(tempCol, key, type);
    }
  };

  // useEffect(() => {
  //   if (props.sortCol && props.sortKey) {
  //     sortAcs(props.data, props.sortType, props.sortKey);
  //   } else {
  //     setData([...props.data]);
  //   }
  // }, [props.sortType, props.sortCol, props.sortKey]);

  return (
    <>
      <Grid
        container
        alignItems="center"
        justify="space-between"
        style={{ marginBottom: "16px" }}
      >
      </Grid>
      <GridHeader
        items={props.headers}
        className={props.headerClassName}
        handleSorting={handleSorting}
      />
      {loading && (
        <Grid
          container
          alignItems="center"
          justify="right"
          alignContent="center"
        >
          <CircularProgress />
        </Grid>
      )}
      {props?.data?.length === 0 && (
        <div className={classes.noDataFound}>NO DATA FOUND</div>
      )}
      {!props?.draggable &&
        props?.data?.length !== 0 &&
        props.data.map(
          (row) => {
            return (
              <GridItem
                key={row.rowKey}
                highlight={row.highlight}
                items={row.rowValue}
                className={props.headerClassName}
              />
            );
          }
        )}
    </>
  );
};

export default CustomerGrid;
